/* eslint-disable */

function getBoundary(map,city) {
  var bdary = new BMap.Boundary();
  bdary.get(city, function (rs) {
    //for循环都删除掉了，只剩下这个
    //网上查了下，东西经南北纬的范围
    var EN_JW = "180, 90;";         //东北角
    var NW_JW = "-180,  90;";       //西北角
    var WS_JW = "-180, -90;";       //西南角
    var SE_JW = "180, -90;";        //东南角
    //4.添加环形遮罩层
    var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, { strokeColor: "none", fillColor: "#081734", fillOpacity:1, strokeOpacity: 0.5 }); //建立多边形覆盖物

    map.addOverlay(ply1);  
    //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
    var ply = new BMap.Polygon(rs.boundaries[0], { strokeWeight: 2, strokeColor: "#00f",fillColor: "" });
    map.addOverlay(ply); 
    // map.setViewport(ply.getPath());    //调整视野
  })
}

function drawBoundary(map,city){
  var bdary = new BMap.Boundary();
  bdary.get(city, function(rs){       //获取行政区域
    var count = rs.boundaries.length; //行政区域的点有多少个
    if (count === 0) {
      console.log('未能获取当前输入行政区域');
      return ;
    }
    var pointArray = [];
    for (var i = 0; i < count; i++) {
      var ply = new BMap.Polygon(rs.boundaries[i], {strokeWeight: 2, strokeColor: "rgba(255,255,255,0.9)",fillColor: "" }); //建立多边形覆盖物
      map.addOverlay(ply);  //添加覆盖物
    }    
  })
}

export {
  getBoundary,
  drawBoundary
}